import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=1343c07f&"
import script from "./Dots.vue?vue&type=script&lang=js&"
export * from "./Dots.vue?vue&type=script&lang=js&"
import style0 from "./Dots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
